import * as React from 'react';

import classnames from 'classnames';

import {ReportEmptyStateCard} from '../../report-empty-state-card';
import type {ReportKey} from '../../report-types';

import ChartEmptyStateHorizontal from './chart-empty-state-horizontal.svg';
import ChartEmptyStateVerticalScribbles from './chart-empty-state-vertical-scribbles.svg';
import ChartEmptyStateVertical from './chart-empty-state-vertical.svg';

import styles from './chart-empty-state.module.css';

const VERT_CHART_AXES_COUNT = 7;
const HORIZ_CHART_AXES_COUNT = 5;

type Props = {
    reportKey?: ReportKey;
    isVertical?: boolean;
    isError?: boolean;
};

export class ChartEmptyState extends React.Component<Props> {
    static defaultProps = {
        vertical: false,
        isError: false,
    };

    render() {
        const flashMessage = this.props.isError ? undefined : (
            <div className={styles.message}>
                <span>We couldn’t find anything with those filters.</span>
            </div>
        );

        if (this.props.reportKey) {
            return (
                <div className={styles['report-container']}>
                    <ReportEmptyStateCard reportKey={this.props.reportKey} />
                    <div className={styles['report-axes-container']}>
                        <div className={styles.axes}>{this.renderAxes(VERT_CHART_AXES_COUNT)}</div>
                    </div>
                </div>
            );
        }

        if (this.props.isVertical) {
            return (
                <div className={classnames(styles.container, styles.vertical)}>
                    {flashMessage}
                    <div className={styles['empty-state-wrapper']}>
                        <ChartEmptyStateVertical />
                        <div className={styles['vertical-axes-container']}>
                            <div className={styles.axes}>
                                {this.renderAxes(VERT_CHART_AXES_COUNT)}
                            </div>
                            <div className={styles.scribbles}>
                                <ChartEmptyStateVerticalScribbles />
                            </div>
                            <div className={styles['scribbles--right']}>
                                <ChartEmptyStateVerticalScribbles />
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className={classnames(styles.container, styles.horizontal)}>
                {flashMessage}
                <div className={styles['empty-state-wrapper']}>
                    <ChartEmptyStateHorizontal />
                    <div className={styles['horizontal-axes']}>
                        {this.renderAxes(HORIZ_CHART_AXES_COUNT)}
                    </div>
                </div>
            </div>
        );
    }

    renderAxes = (count: number) => {
        const axes = [];
        for (let i = 0; i < count; ++i) {
            axes.push(<div key={i} />);
        }

        return axes;
    };
}
